import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AuthenticatedUser } from '../../../services/auth/authenticated-user.model';
import { MenuItem, MessageService } from 'primeng/api';

import { DeviceManagerService } from '../../../core/services/device-manager.service';
import { AuthManagerService } from '../../../services/auth/auth-manager.service';
import { SubsidiaryManagerService } from '../../../services/subsidiary/subsidiary-manager.service';
import { Subsidiary } from '../../../services/subsidiary/subsidiary.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@UntilDestroy()
@Component({
    selector: 'ls-subsidiary-toolbar',
    templateUrl: './subsidiary-toolbar.component.html',
    styleUrls: [ './subsidiary-toolbar.component.less' ]
})
export class SubsidiaryToolbarComponent implements OnInit, OnDestroy
{
    @HostBinding('class') get classes(): string { return 'dark'; }

    currentUser: AuthenticatedUser;
    subsidiaryItems: MenuItem[];
    addSubsidiaryFormVisible: boolean = false;

    addSubsidiaryForm: FormGroup;

    private subsidiaries: Subsidiary[] = [];

    constructor(public deviceManager: DeviceManagerService,
                public authManager: AuthManagerService,
                private subsidiaryManager: SubsidiaryManagerService,
                private fb: FormBuilder,
                private messageService: MessageService) {
                    this.addSubsidiaryForm = this.fb.group({
                        name: ['', Validators.required],
                        abbreviatedName: ['', Validators.required],
                        displayName: ['', Validators.required],
                        legalName: ['', Validators.required]
                    })
                }

    ngOnInit(): void
    {
        this.authManager.currentUserChanged.pipe(untilDestroyed(this)).subscribe(user => {
            this.currentUser = user;
        });
        this.currentUser = this.authManager.currentUser;
        this.loadMenuItems();
    }

    ngOnDestroy(): void {
        /* Implemented to support untilDestroyed */
    }

    loadMenuItems(): void
    {
        if (this.subsidiaryItems != null) return;

        this.subsidiaryItems = [ { label: 'Loading subsidiaries...', items: [] } ];
        this.subsidiaryManager.getSubsidiaries().subscribe(subsidiaries =>
        {
            this.subsidiaries = subsidiaries;
            this.subsidiaryItems = this.subsidiaries.map(subsidiary =>
            {
                return { label: subsidiary.name, command: () => this.subsidiarySelected(subsidiary) };
            });
        });
    }

    get subsidiaryName(): string { return this.subsidiaries.find(s => s.id === this.authManager.currentUser.subsidiaryId)?.name; }

    private subsidiarySelected(subsidiary: Subsidiary): void
    {
        if (this.currentUser.subsidiaryId === subsidiary.id) return;
        this.authManager.loginWithRefreshToken(subsidiary.id, undefined).subscribe();
    }

    addSubsidiary(){
        if(!this.addSubsidiaryForm.valid) {
            this.messageService.add({ 
                severity: 'error', 
                summary: 'Add Subsidiary', 
                detail: `Please fill required fields.` 
            });
        }

        this.subsidiaryManager.addSubsidiary(this.addSubsidiaryForm.value).subscribe(
            (subsidiary: Subsidiary) => {
                this.subsidiaries.push(subsidiary);
                this.subsidiaryItems.push({label: subsidiary.name, command: () => this.subsidiarySelected(subsidiary)})
                this.messageService.add({ 
                    severity: 'success', 
                    summary: 'Add Subsidiary', 
                    detail: `Subsidiary added succesfuly'.` 
                });
            },
            error => {
                this.messageService.add({
                    severity: 'error',
                    summary: `Add Subsidiary`,
                    detail: ErrorHandlerService.handleError(this, error, 'addSubsidiary()', false, false)
                });
            }
        )
    }
}
